import { useForm } from "react-hook-form";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { FormSwitchInput } from "../../../../../../common/components/masked_inputs/react_forms/form_switch_input";
import { zodResolver } from "@hookform/resolvers/zod";
import { FormSelectInput } from "../../../../../../common/components/masked_inputs/react_forms/form_select_input";
import { useEffect, useMemo } from "react";
import { ServicoProdutoLista } from "../../../../domain/models/servico_produto_lista";
import { ServicoProdutoForm, ServicoProdutoSchema } from "../../../schemas/ServicosProdutos_lista/servico_produto";

import FormContainer from "../../../../../../common/components/form_container";
import DefaultFormInput from "../../../../../../common/components/default_form_input";
import PrimaryButton from "../../../../../../common/components/primary_button";

/**
 * ServicosProdutosModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  selectedProdutoServico: ServicoProdutoLista | null,
  onClose: () => void;
  onSubmit: (form: ServicoProdutoForm) => void;
  onOpenChangeHistory: () => void;
};

export const ServicosProdutosModal = ({
  open,
  saving,
  loading,
  selectedProdutoServico,
  onClose,
  onSubmit,
  onOpenChangeHistory,
}: Props) => {

  const hookForm = useForm<ServicoProdutoForm>({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    resolver: zodResolver(ServicoProdutoSchema),
  });

  const tipoOptions = useMemo(() => {
    return [
      {
        id: 1,
        label: 'Produto',
      },
      {
        id: 2,
        label: 'Serviço',
      }
    ];
  }, [
  ]);

  useEffect(() => {
    if (open) {
      if (selectedProdutoServico) {
        hookForm.setValue('ativo', selectedProdutoServico.ativo ?? false);
        hookForm.setValue('produtoServico', selectedProdutoServico.descricao ?? '');
        hookForm.setValue('tipo', selectedProdutoServico.tipo === 'P' ? 1 : 2);
        hookForm.setValue('unidade', selectedProdutoServico.unidade ?? '');
        hookForm.setValue('norma', selectedProdutoServico.norma ?? '');
      } else {
        hookForm.reset({ ativo: true, tipo: 1 });
      }
    }
  }, [
    open,
    selectedProdutoServico,
    hookForm,
  ]);

  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={loading}
      title="Serviço/Produto"
      leftButtonSlot={
        (selectedProdutoServico && selectedProdutoServico.idProdutoServico) &&
        <PrimaryButton
          buttonColor="yellow"
          onClick={() => onOpenChangeHistory()}>
          <span className="text-xs">
            Historico de alterações
          </span>
        </PrimaryButton>
      }
      onClose={onClose}
      onSubmit={hookForm.handleSubmit(onSubmit)} >
      <FormContainer title="Informações" arrangement="fullRow">
        <>
          <FormSwitchInput
            name='ativo'
            readOnly={saving}
            reactHookForm={hookForm}
          />

          <DefaultFormInput
            name='produtoServico'
            label='Produto/Serviço'
            required={true}
            reactHookForm={hookForm}
          />

          <FormSelectInput
            name='tipo'
            label='Tipo'
            showSelectionLabel={false}
            options={tipoOptions}
            reactHookForm={hookForm}
          />

          <DefaultFormInput
            name='unidade'
            label='Unidade'
            reactHookForm={hookForm}
          />

          <DefaultFormInput
            name='norma'
            label='Norma'
            reactHookForm={hookForm}
          />
        </>
      </FormContainer>
    </BaseFormControlledModal >
  );
}